import React from 'react';
import { Radio } from 'antd';
import { RadioButtonProps } from 'antd/lib/radio/radioButton';

export type { RadioButtonProps };

const ProRadioButton: React.FC<RadioButtonProps> = React.forwardRef<
  any,
  RadioButtonProps
>((props, ref) => {
  const { children, ...resProps } = props;
  return (
    <Radio.Button ref={ref} {...resProps}>
      {children}
    </Radio.Button>
  );
});

export default ProRadioButton;
